import React, { useState } from "react";
import { Row, Col, Card, Input, Tabs } from "antd";
import FilterBar from "../../components/FilterBar";
import TopLeaderBoard from "./TopLeaderBoard";
import LeaderBoardBySkill from "./LeaderBoardBySkill";
import useDebounce from "../../hooks/useDebounce";

const { Search } = Input;
const { TabPane } = Tabs;

function Index() {
  const sectionName = "Leaderboard";
  const [searchText, setSearchText] = useState("");
  const debouncedSearchText = useDebounce(searchText, 300);

  const onSearch = (e) => {
    setSearchText(e.target.value);
  };

  return (
    <>
      <div className="tabled">
        <Row gutter={[24, 0]}>
          <Col xs={24} xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title={`${sectionName} Manager`}
            // extra={
            //   <FilterBar
            //     searchContent={
            //       <Search
            //         size="large"
            //         onChange={onSearch}
            //         value={searchText}
            //         onPressEnter={onSearch}
            //         allowClear
            //         placeholder={`Search By User Name`}
            //       />
            //     }
            //   />
            // }
            >
              <div style={{ padding: "0 24px" }}>
                <Tabs defaultActiveKey="1">
                  <TabPane tab="Top LeaderBoard" key="1">
                    <TopLeaderBoard searchText={debouncedSearchText} />
                  </TabPane>
                  <TabPane tab="Skill LeaderBoard" key="2">
                    <LeaderBoardBySkill searchText={debouncedSearchText} />
                  </TabPane>
                </Tabs>
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default Index;
